import React from 'react'
import MaterialSymbol from '../material-symbol'

const LibraryBooks = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="library_books" {...props} />
))

LibraryBooks.displayName = 'LibraryBooks'

export default LibraryBooks
